import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import { ButtonHTMLAttributes, ChangeEventHandler, FormEventHandler, FormHTMLAttributes, InputHTMLAttributes, RefObject } from 'react'

// Components
import Icon from '@/assets/icons'
import { SearchButton } from '@/components/pages/livemallclub/Explore/components/Preferences'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type SearchBarProps = {
  onChange?: ChangeEventHandler<HTMLInputElement>
  onSubmit?: FormEventHandler<HTMLFormElement>
  inputProps?: InputHTMLAttributes<HTMLInputElement>
  formProps?: FormHTMLAttributes<HTMLFormElement>
  inputRef?: RefObject<HTMLInputElement>
  onClear?: () => void
  showClearButton?: boolean
  showSearchIcon?: boolean
  handleHideSearchBar?: () => void
  showCancelButton?: boolean
}

const ClearButton = (props: ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <button className={cx('search-bar-clear-button')} {...props} type='button'>
      <Icon.Clear />
    </button>
  )
}

export const SearchBar = ({
  onChange,
  onSubmit,
  inputProps,
  inputRef,
  onClear,
  showClearButton = true,
  showSearchIcon = true,
  formProps,
  handleHideSearchBar,
  showCancelButton = false,
}: SearchBarProps) => {
  const { t } = useTranslation()
  const placeholder = inputProps?.placeholder ?? t('Search_Bar_Placeholder')

  return (
    <div className={cx('search-bar')}>
      {showSearchIcon && <SearchButton onClick={onSubmit as ButtonHTMLAttributes<HTMLButtonElement>['onClick']} />}
      <form className={cx('search-bar-form')} onSubmit={onSubmit} {...formProps}>
        <input
          className={cx('search-bar-input')}
          type='search'
          enterKeyHint='search'
          placeholder={placeholder}
          ref={inputRef}
          onChange={onChange}
          {...inputProps}
        />
        {showClearButton && <ClearButton onClick={onClear} />}
      </form>
      {showCancelButton && (
        <button className={cx('search-bar-cancel-button')} onClick={handleHideSearchBar}>
          {t('Common_Cancel_LowerCase')}
        </button>
      )}
    </div>
  )
}
